import { fetcher } from '../fetcher'
import useSWR from 'swr'

export const useCats = (page: number, limit: number, gender?: string) => {
  const offset = (page - 1) * limit
  const { data, error, isLoading, mutate } = useSWR(
    `/cats?page=${page}&offset=${offset}&limit=${limit}${
      gender ? `&gender=${gender}` : ''
    }`,
    fetcher
  )

  return {
    data,
    error,
    isLoading,
    mutate,
  }
}

export const useCatById = (id: string | null) => {
  const { data, error, isLoading, mutate } = useSWR(
    id ? `/cats/${id}` : null,
    fetcher
  )

  return {
    data,
    error,
    isLoading,
    mutate,
  }
}
